const getApiBase = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  if (process.env.NODE_ENV === "production") {
    return window.location.origin;
  }
  return "http://localhost:5003";
};

const API_BASE = `${getApiBase()}/api/mylego`;
let itemsCache = null;
let itemsRequest = null;
let ratesCache = null;
let ratesRequest = null;
const legoNameCache = new Map();

async function request(path = "", options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  if (!response.ok) {
    let message = `Request failed: ${response.status}`;
    try {
      const body = await response.json();
      if (body.message) message = body.message;
    } catch (_error) {}
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
}

export const api = {
  getItems: async () => {
    if (itemsCache) {
      return itemsCache;
    }
    if (!itemsRequest) {
      itemsRequest = request("/")
        .then((items) => {
          itemsCache = items;
          return items;
        })
        .finally(() => {
          itemsRequest = null;
        });
    }
    return itemsRequest;
  },
  getExchangeRates: async () => {
    if (ratesCache) return ratesCache;
    if (!ratesRequest) {
      ratesRequest = request("/exchange-rates")
        .then((rates) => {
          ratesCache = rates;
          return rates;
        })
        .finally(() => {
          ratesRequest = null;
        });
    }
    return ratesRequest;
  },
  getItem: (id) => request(`/${id}`),
  resolveLegoName: async (legoId) => {
    const key = String(legoId || "").trim();
    if (!key) return null;
    if (legoNameCache.has(key)) {
      return legoNameCache.get(key);
    }
    const result = await request(`/resolve/${encodeURIComponent(key)}`);
    legoNameCache.set(key, result);
    if (result?.legoId && result.legoId !== key) {
      legoNameCache.set(result.legoId, result);
    }
    return result;
  },
  createItem: async (payload) => {
    const result = await request("/", { method: "POST", body: JSON.stringify(payload) });
    itemsCache = null;
    return result;
  },
  updateItem: async (id, payload) => {
    const result = await request(`/${id}`, { method: "PUT", body: JSON.stringify(payload) });
    itemsCache = null;
    return result;
  },
  deleteItem: async (id) => {
    const result = await request(`/${id}`, { method: "DELETE" });
    itemsCache = null;
    return result;
  },
};
